"use client";

import { useCallback, useState } from "react";
import { rememberRoomLink } from "@/lib/room-client";

export interface RoomAccess {
  unlocked?: boolean;
  roomLink?: string;
}

export function useRoomAccess() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [roomLink, setRoomLink] = useState("");
  const acceptRoomAccess = useCallback((access: RoomAccess) => {
    setIsUnlocked(Boolean(access.unlocked));
    if (access.roomLink) {
      rememberRoomLink(access.roomLink);
      setRoomLink(new URL(access.roomLink, window.location.origin).toString());
    }
  }, []);
  function resetRoomAccess() {
    setIsUnlocked(false);
    setRoomLink("");
  }
  return { isUnlocked, roomLink, acceptRoomAccess, resetRoomAccess };
}
